import "../../BioLinks.css";
import BioCard from "./BioCard";
import bgImage from "../../Assets/ServiceImg/fpv.webp";
import { Helmet } from "react-helmet-async";


const Links = () => {
   return (
      <div className="bio-container">
         <Helmet>
            <title>Mis redes sociales y contacto | Joan Company</title>
            <meta
               key="description"
               name="description"
               content="Encuentra mis redes sociales y formas de contacto para seguir mi trabajo y proyectos."
            />
            <meta
               key="keywords"
               name="keywords"
               content="redes sociales, contacto, portfolio, Joan Company, drones, fpv, grabación con drones"
            />
            <link rel="canonical" href="https://www.joancompany.es/links" />
            <meta property="og:image" content={bgImage} />
         </Helmet>
         <div
            className="bio-background"
            style={{ backgroundImage: `url(${bgImage})` }}
         ></div>
         <BioCard />
      </div>
   );
}

export default Links;
